import { OnDemandLearnerMaterialsV1NaptimeResource } from './__generated__/OnDemandLearnerMaterialsV1';

class OnDemandLearnerMaterials extends OnDemandLearnerMaterialsV1NaptimeResource {
  static RESOURCE_NAME = 'onDemandLearnerMaterials.v1' as const;
}

export default OnDemandLearnerMaterials;
